(() => {
  if (window.location.hash !== '#bundlePreviewWrapper') return;
  const scrollToBuilder = () => {
    const builder = document.getElementById('bundlePreviewWrapper');
    if (!builder || !builder.getClientRects().length) return false;
    builder.scrollIntoView({ block: 'start', behavior: 'instant' });
    builder.setAttribute('tabindex', '-1');
    builder.focus({ preventScroll: true });
    return true;
  };
  if (scrollToBuilder()) return;
  const observer = new MutationObserver(() => {
    if (scrollToBuilder()) {
      observer.disconnect();
      clearTimeout(timeout);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const timeout = setTimeout(() => observer.disconnect(), 15000);
})();
